import { ExchangeRateExample } from "@/modules/currency/ExchangeRateExample.tsx";
import { useCurrentCurrency } from "@/modules/currency/useCurrentCurrency.ts";
import { Trans } from "@lingui/react/macro";

export function DisplayCurrencyRate() {
    const currency = useCurrentCurrency();
    if (currency.isSite) {
        return null;
    }

    return (
        <div className="color-muted font-size-small">
            <Trans>Exchange rate</Trans>: <ExchangeRateExample currency={currency} />
        </div>
    );
}
